// extracted by mini-css-extract-plugin
module.exports = {"title":"cutleryDelivery_title__3Ig9H","container":"cutleryDelivery_container__3FGEu","item":"cutleryDelivery_item__3rosk","value":"cutleryDelivery_value__1cfUG"};